module.exports = __webpack_public_path__ + "img/Marquise vue 1.4c7ae4e2.jpg";